"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _types = require("../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("footer", _flowRuntime["default"].ref(_types.FooterDefinition))));

var _default = function _default(_arg) {
  var footer = _arg.footer;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "small"
  }, footer.html ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  _react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: footer.html
    }
  }) : /*#__PURE__*/_react["default"].createElement("div", null, footer.text));
};

exports["default"] = _default;